import React from "react";
import { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react";
import { Alert, Button, Box, Typography, Checkbox, FormGroup, FormControlLabel } from "@mui/material";
import { Spinner } from "/@/app/components/Spinner";
import { freeMeasurementsViewState } from "/@/app/views/FreeMeasurementsView/FreeMeasurementsViewState";


export const ChangeSections = observer(({ state, onDone }) => {
    const sections = freeMeasurementsViewState.sections.filter(s => s.slug !== "other");
    return <_ChangeSections state={state} allSections={sections} onDone={onDone} />;
});

const _ChangeSections = observer(({ state, allSections, onDone }) => {
    const isSaving = state.saveStatus === "saving";
    const doSave = () => {
        let selected = state.sections.map((s) => s.id);
        for (const [id, change] of Object.entries(changes)) {
            if (change === "add") {
                selected.push(parseInt(id));
            } else if (change === "delete") {
                selected = selected.filter((s) => s !== parseInt(id));
            }
        }
        state.saveSections(selected).then(() => {
            onDone();
        });
    }

    // something that accumulates changes.
    // FIXME remove, as it duplicates checkboxStates, and simplify the code.
    const [changes, setChanges] = useState({});
    const addItem = (key, value) => {
        setChanges(prevState => ({
            ...prevState,
            [key]: "add",
        }));
    };
    const deleteItem = (key) => {
        setChanges(prevState => ({
            ...prevState,
            [key]: "delete",
        }));
    };

    // Initial states.
    const checkboxStates = {};
    for (const section of allSections) {
        checkboxStates[section.id] = useState(state.sections.map((s) => s.id).includes(section.id));
    }

    return (
        <>
            <Typography variant="h6" component="h2">
                Разделы для параметра
            </Typography>

            <Box sx={{ mt: 2, display: "flex", flexFlow: "column nowrap", gap: 1, alignItems: "center", overflowY: "auto" }}>
                <FormGroup>
                    {allSections.map(section => (
                        <FormControlLabel
                            key={section.id}
                            control={
                                <Checkbox
                                    inputProps={{ 'aria-label': 'controlled' }}
                                    checked={checkboxStates[section.id][0]}
                                    onChange={(e) => {
                                        checkboxStates[section.id][1](e.target.checked);
                                        if (e.target.checked) {
                                            addItem(section.id);
                                        } else {
                                            deleteItem(section.id);
                                        }
                                    }}
                                />
                            }
                            label={section.name_ru}
                        />
                    ))}
                </FormGroup>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={doSave}
                    disabled={isSaving}
                    sx={{ mb: 2 }}
                >
                    {isSaving
                        ? <Spinner size={30} sx={{ color: "white" }}/>
                        : "Сохранить"
                    }
                </Button>
            </Box>
        </>
    );
});
